import { render, staticRenderFns } from "./BlockFunctionExamples.vue?vue&type=template&id=a3c2523e&"
import script from "./BlockFunctionExamples.vue?vue&type=script&lang=js&"
export * from "./BlockFunctionExamples.vue?vue&type=script&lang=js&"
import style0 from "./BlockFunctionExamples.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports